module.exports = __webpack_public_path__ + "img/icon_safari@2x.fe66f899.png";